module.exports = __webpack_public_path__ + "static/img/fun2win-favicon.88f001d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons/fun2win-favicon.png
// module id = 2528
// module chunks = 0